import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { useTrackWithUser } from '@ion/api';
import { FileCode01Icon } from '@metarouter-private/mr-mui';

import { routes } from 'app/constants';
import ActionIconButton from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/cells/shared/ActionIconButton';

export default function OpenPlaybookButton({ integration, playbookId }) {
  const history = useHistory();
  const [trackPlaybookOpened] = useTrackWithUser('pipeline_integration_playbook_opened');
  const { id, name, starterkitId } = integration;

  const onClick = () => {
    trackPlaybookOpened({ starterkitId });
    history.push(routes.editPlaybook, { integrationId: id, playbookId });
  };

  return (
    <ActionIconButton
      tooltipMessage="Open Playbook"
      ariaLabel={`Open the playbook for ${name}`}
      dataTestId="openPlaybookButton"
      onClick={onClick}
    >
      <FileCode01Icon color="action" fontSize="medium" />
    </ActionIconButton>
  );
}

OpenPlaybookButton.propTypes = {
  integration: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    starterkitId: PropTypes.string.isRequired,
  }).isRequired,
  playbookId: PropTypes.string.isRequired,
};
